module.exports = __webpack_public_path__ + "img/Jump Casting43.ee40fb01.jpg";